import {
  DEFAULT_TABLE_PAGE_SIZE,
  LIST_GC_TIME_MS,
  LIST_STALE_TIME_MS,
  useApiClient,
} from '@klareospace/pharos-lib-front-utils';
import type { PaginatedResponse, UserWithResolvedScopes } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchDriversParams } from '../api';
import { createDriverApi, driverKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseDriversOptions extends SearchDriversParams {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useDrivers(options?: UseDriversOptions): UseQueryResult<PaginatedResponse<UserWithResolvedScopes>> {
  const client = useApiClient('admin-auth');
  const api = createDriverApi(client);

  const { enabled, ...filters } = options ?? ({ page: 1, pageSize: DEFAULT_TABLE_PAGE_SIZE } as UseDriversOptions);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: (): Promise<PaginatedResponse<UserWithResolvedScopes>> => api.searchDrivers(filters),
    queryKey: driverKeys.list(filters),
    staleTime: LIST_STALE_TIME_MS,
  });
}
